/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentMethodCode } from './paymentMethodCode.model';


export interface ContactPaymentDataDto { 
    account?: string;
    bankCode?: string;
    bankName?: string;
    iban?: string;
    id?: number;
    name?: string;
    paymentMethod: PaymentMethodCode;
    specSym?: string;
    swift?: string;
    varSym?: string;
    withdrawPostage: boolean;
}
export namespace ContactPaymentDataDto {
}


